import React, { FC } from 'react';

import { useCommonData } from '@stores/global-data';

import { sendSubscribeTelegramClickEvent } from '@utils/analytics';

import { Button } from '@components/common/Button/Button';
import { TelegramColorIcon } from '@components/icons/TelegramColorIcon';

import styles from './FooterTelegram.module.scss';

export const FooterTelegram: FC = () => {
    const {
        settings: {
            telegram_block: { title, description, button_text, button_url },
        },
    } = useCommonData();

    return (
        <div className={styles.root}>
            <div className={styles.telegram}>
                <TelegramColorIcon className={styles.telegramIcon} />
                <div className={styles.textWrapper}>
                    <h3 className={styles.title}>{title}</h3>
                    <p className={styles.caption}>{description}</p>
                </div>
            </div>
            <div>
                {button_url !== null && (
                    <Button
                        link={button_url}
                        onClick={sendSubscribeTelegramClickEvent}
                        target="_blank"
                        variant="green"
                        isFullWith
                    >
                        {button_text}
                    </Button>
                )}
            </div>
        </div>
    );
};
